module.exports = __webpack_public_path__ + "img/sprite.ed6f035f.svg";